



















































































































































import { Component, Mixins } from "vue-property-decorator";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import dateranges from "@/data/dateranges";

@Component({
  components: {
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "cash-total": () => import("@/components/app/global/stats/cashTotal.vue"),

    "cash-total-recurrent": () =>
      import("@/components/app/global/stats/cashTotalRecurrent.vue"),
    "cash-total-new-contract": () =>
      import("@/components/app/global/stats/cashTotalNewContract.vue"),
    "cash-total-credit-note": () =>
      import("@/components/app/global/stats/cashTotalCreditNote.vue"),
    "cash-total-credit-note-for-refund": () =>
      import("@/components/app/global/stats/cashTotalCreditNoteForRefund.vue"),

    // Invoices
    "invoices-category-total": () =>
      import("@/components/app/global/stats/invoicesCategoryTotal.vue"),
    "invoices-category-new-contract": () =>
      import("@/components/app/global/stats/invoicesCategoryNewContract.vue"),
    "invoices-category-recurrent": () =>
      import("@/components/app/global/stats/invoicesCategoryRecurrent.vue"),
    "invoices-category-total-paid": () =>
      import("@/components/app/global/stats/invoicesCategoryTotalPaid.vue"),
    "invoices-category-total-unpaid": () =>
      import("@/components/app/global/stats/invoicesCategoryTotalUnpaid.vue"),
    "invoices-category-total-overdue": () =>
      import("@/components/app/global/stats/invoicesCategoryTotalOverdue.vue"),

    "orders-total-new": () =>
      import("@/components/app/global/stats/ordersTotalNew.vue"),

    //Clients
    "contract-clients": () =>
      import("@/components/app/global/stats/contractClients.vue"),
    "contract-clients-active": () =>
      import("@/components/app/global/stats/contractClientsActive.vue")
  }
})
export default class MonthlyRunRate extends Mixins(StatsStorageMixin) {
  public range = this.tryGetStatDateFromStorage(dateranges.ranges.last30days);
  public currencyCode = null;
}
